<button type="button" class="mincultura-btn" [attr.style]="'border-radius:' + borderRadius + 'px;'"
    [disabled]="isDisabled" [ngClass]="[
    color, 
    colorHover ? 'hover-' + colorHover : '',
    (notificationCount && notificationCount > 0) ? 'overflow-visible' : '',
    texto ? 'with-text' : ''
  ]">

    <div class="icon-wrapper">
        <svg [attr.width]="sizewidth" [attr.height]="sizeheight">
            <use [attr.xlink:href]="'assets/layout/icons/icons-mincultura.svg#' + 'icon-' + nombre"></use>
        </svg>

        <span class="notification-badge" *ngIf="notificationCount && notificationCount > 0">
            {{ notificationCount }}
        </span>
    </div>

    <span class="btn-text" *ngIf="texto">{{ texto }}</span>

</button>